import { callFirebaseFunction } from '@/v2/utils/firebase';
import { useAuthStore } from '@/v2/store/shared/auth-store';

const currentTenant = () => useAuthStore().tenantId;
const currentActor = () => useAuthStore().user?.id;

export const activatePlugin = (pluginId) =>
	callFirebaseFunction('activatePlugin', {
		tenantId: currentTenant(),
		pluginId,
		activatedBy: currentActor(),
	});

export const deactivatePlugin = (pluginId) =>
	callFirebaseFunction('deactivatePlugin', {
		tenantId: currentTenant(),
		pluginId,
		deactivatedBy: currentActor(),
	});

export const getPluginStatus = (pluginId) =>
	callFirebaseFunction(
		'getPluginStatus',
		{ params: { tenantId: currentTenant(), pluginId } },
		{ method: 'get' },
	);

export const listTenantPlugins = () =>
	callFirebaseFunction(
		'listTenantPlugins',
		{ params: { tenantId: currentTenant() } },
		{ method: 'get' },
	);
